const isEqualAs = (fieldName: string) => ({
  errorMessage: 'ERROR_IS_EQUAL',
  errorMessageParams: { fieldName },
  rule: (value: any, values: any) => value === values[fieldName],
});

export default isEqualAs;
